import PropTypes from 'prop-types';
import { compact, isEmpty, without } from 'lodash';
import Icon from "../../Icon/Icon";
import AllOrOne from "../../AllOrOne/AllOrOne";
import EmailAddress from "../EmailAddress/EmailAddress";
import Location from "../../Location/Location/Location";
import PhoneNumbers from "../PhoneNumbers/PhoneNumbers";
import arrays from "../../../utils/Arrays";
import urls from "../../../utils/Urls";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ContactInformation = _ref => {
  let {
    addressCount = '',
    addresses = [],
    className = '',
    email_addresses = [],
    headerText = 'Contact Information',
    hideLabels = false,
    isInNetworkGroup = true,
    openLink = typeof window !== 'undefined' ? window.open : () => {},
    originLatLng = [],
    phone_numbers = [],
    primary_contact_name = '',
    showContactInfoHeader = true,
    showLocationHours = false,
    showMore = false,
    website_url = '',
    serve = false
  } = _ref;
  const primaryEmail = arrays.findPrimaryOrFirst(email_addresses);
  const emailAdresses = compact([primaryEmail, ...without(email_addresses, primaryEmail)]);
  const validExternalUrl = urls.addHttpIfNeeded(website_url);
  const showHeader = showContactInfoHeader && (!isEmpty(email_addresses) || !isEmpty(phone_numbers) || !isEmpty(primary_contact_name) || !isEmpty(website_url));
  const handleOpenLink = e => {
    e.preventDefault();
    openLink(validExternalUrl);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "text-sm text-text-blue ".concat(className),
    children: [showHeader && /*#__PURE__*/_jsx("h4", {
      className: "flex mb-1 font-heavy-font",
      children: headerText
    }), primary_contact_name ? /*#__PURE__*/_jsxs("div", {
      className: "flex text-sm text-text-blue mb-1",
      children: [/*#__PURE__*/_jsx(Icon, {
        className: "align-middle mr-2 my-auto",
        color: "".concat(isInNetworkGroup ? 'action-blue' : 'brand-blue'),
        icon: "User"
      }), /*#__PURE__*/_jsx("span", {
        className: "align-middle flex pl-1",
        children: primary_contact_name
      })]
    }) : null, /*#__PURE__*/_jsx(AllOrOne, {
      children: !serve && addresses && addresses.map(location => /*#__PURE__*/_jsx(Location, {
        addressCount: addressCount,
        className: "align-middle flex mb-1 text-sm text-text-blue",
        isInNetworkGroup: isInNetworkGroup,
        location: location,
        originLatLng: originLatLng,
        showHours: showLocationHours,
        showMore: showMore
      }, "".concat(location === null || location === void 0 ? void 0 : location.id, "-location")))
    }), /*#__PURE__*/_jsx(AllOrOne, {
      showAll: showMore,
      children: phone_numbers && /*#__PURE__*/_jsx(PhoneNumbers, {
        hideLabels: hideLabels,
        isInNetworkGroup: isInNetworkGroup,
        phone_numbers: phone_numbers
      })
    }), /*#__PURE__*/_jsx(AllOrOne, {
      showAll: showMore,
      children: !isEmpty(email_addresses) && emailAdresses.map(email => /*#__PURE__*/_jsxs("div", {
        className: "flex mb-1 text-sm text-text-blue",
        children: [/*#__PURE__*/_jsx(Icon, {
          className: "align-middle mr-2 my-auto",
          color: "".concat(isInNetworkGroup ? 'action-blue' : 'brand-blue'),
          icon: "Email"
        }), /*#__PURE__*/_jsx(EmailAddress, {
          className: "align-middle pl-1",
          emailAddress: email
        })]
      }, "email-".concat(email !== null && email !== void 0 && email.email_address ? email.email_address : email)))
    }), website_url ? /*#__PURE__*/_jsxs("div", {
      className: "mb-1 text-sm text-text-blue",
      children: [/*#__PURE__*/_jsx(Icon, {
        className: "align-middle mr-2",
        color: "".concat(isInNetworkGroup ? 'action-blue' : 'brand-blue'),
        icon: "Globe"
      }), /*#__PURE__*/_jsx("a", {
        id: "website-link",
        className: "align-middle pl-1 focus:outline-solid-offset text-action-blue",
        href: "#",
        onClick: handleOpenLink,
        title: 'Organization Website',
        target: "_blank",
        rel: "noreferrer noopener",
        children: validExternalUrl
      })]
    }) : null]
  });
};
ContactInformation.propTypes = {
  addressCount: PropTypes.string,
  addresses: PropTypes.array,
  className: PropTypes.string,
  email_addresses: PropTypes.array,
  headerText: PropTypes.node,
  hideLabels: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  openLink: PropTypes.func,
  originLatLng: PropTypes.array,
  phone_numbers: PropTypes.array,
  primary_contact_name: PropTypes.string,
  showContactInfoHeader: PropTypes.bool,
  showLocationHours: PropTypes.bool,
  showMore: PropTypes.bool,
  website_url: PropTypes.string,
  serve: PropTypes.bool
};
export default ContactInformation;
//# sourceMappingURL=ContactInformation.js.map